export default {
    getBookingForm: (state) => {
        return state.bookingForm
    },
    getBooking: (state) => {
        return state.booking
    },
    getBookingChangelog: (state) => {
        return state.bookingChangelog
    },
    getIsReturnBooking: (state) => {
        return state.isReturnBooking
    },
    getReloadBooking: (state) => {
        return state.reloadBooking
    },
    getBookingRepeatServiceId: (state) => {
        return state.bookingRepeatServiceId
    }
}
